import axios from "axios";

export const API_BASE_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/+$/, "");

const client = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

export function getApiErrorStatus(error) {
  return error?.response?.status || null;
}

export function getApiErrorMessage(error, fallback = "Something went wrong") {
  if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
    return "Request timed out. Please try again.";
  }
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    return first?.msg || fallback;
  }
  return error?.message || fallback;
}

export async function createMeeting({
  title,
  days,
  timeSlots,
  preferredSlots,
  timezone,
  durationMinutes,
  allowResultsPublic,
}) {
  const { data } = await client.post("/meetings", {
    title,
    days,
    timeSlots,
    preferredSlots: preferredSlots || [],
    timezone: timezone || "America/New_York",
    durationMinutes: durationMinutes || 30,
    allowResultsPublic: Boolean(allowResultsPublic),
  });

  return data;
}

export async function getMeeting(id) {
  const { data } = await client.get(`/meetings/${encodeURIComponent(id)}`);
  return data;
}

export async function addResponse(id, { name, slots }) {
  const { data } = await client.post(
    `/meetings/${encodeURIComponent(id)}/responses`,
    {
      name,
      slots: slots || [],
    }
  );
  return data;
}

export async function getResults(id, adminToken) {
  const { data } = await client.get(`/meetings/${encodeURIComponent(id)}/results`, {
    headers: adminToken ? { "X-Admin-Token": adminToken } : undefined,
  });
  return data;
}

export async function updateMeeting(id, updates, adminToken) {
  const { data } = await client.patch(
    `/meetings/${encodeURIComponent(id)}`,
    updates,
    {
      headers: adminToken ? { "X-Admin-Token": adminToken } : undefined,
    }
  );
  return data;
}

export async function finalizeMeeting(id, selectedSlot, adminToken) {
  const { data } = await client.post(
    `/meetings/${encodeURIComponent(id)}/finalize`,
    { selectedSlot },
    {
      headers: adminToken ? { "X-Admin-Token": adminToken } : undefined,
    }
  );
  return data;
}

// Made with Bob
